export default __webpack_public_path__ + "assets/images/06615659114dcdec0e67a6030320a3a7.svg";